<template>
  <div class="ClassificationRules">
    <v-row class="ClassificationRules__filter-row">
      <v-col>
        <v-btn text small color="primary" @click="isDialogOpen = true">
          + Add Classification Rule
        </v-btn>
      </v-col>
    </v-row>

    <v-data-table
        class="ClassificationRules__data-table elevation-0"
        outlined
        item-key="id"
        :item-class="() => 'ClassificationRules__data-table-row'"
        :items="Rules"
        :headers="headers"
        :loading="fetchRulesLoading || deleteRuleLoading"
        @click:row="handleGoToRule"
    >
      <template v-slot:[`item.documentType`]="{ item }">
        <v-chip small>
          <strong>
            {{ item.documentType }}
          </strong>
        </v-chip>
      </template>

      <template v-slot:[`item.scope`]="{ item }">
        <v-chip small :color="item.customer_id ? 'blue' : 'green'" dark>
          <strong>
            {{ item.customerId !== null ? 'Customer' : 'System' }}
          </strong>
        </v-chip>
      </template>

      <template v-slot:[`item.actions`]="{ item }">
        <v-btn
          icon
          small
          color="primary"
          @click.stop="editRule(item)"
          class="mr-1"
          :disabled="isSystemRule(item)"
          :title="isSystemRule(item) ? 'System rules cannot be edited' : 'Edit rule'"
        >
          <v-icon small> mdi-pencil </v-icon>
        </v-btn>
        <v-btn
          icon
          color="error"
          @click.stop="triggerDelete(item)"
          :disabled="isSystemRule(item)"
          :title="isSystemRule(item) ? 'System rules cannot be deleted' : 'Delete rule'"
        >
          <v-icon small> mdi-delete </v-icon>
        </v-btn>
      </template>
    </v-data-table>

    <action-prompt
        v-model="showDeleteRuleModal"
        v-if="showDeleteRuleModal"
        action-text="Delete"
        :action="removeRule"
        :loading="deleteRuleLoading"
        header="Delete Rule"
        :body="deleteMessageBody"
        action-type="error"
    />

    <CreateClassificationRule :dialog="isDialogOpen" @close="handleDialogClose" />
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import ActionPrompt from '@/components/modals/action-prompt/action-prompt.vue';
import CreateClassificationRule from '@/components/modals/create-classification-rule/create-classification-rule.vue';

const { mapGetters: rulesGetters, mapActions: rulesActions } =
    createNamespacedHelpers('classificationRules');
const { mapGetters: customerGetters } = createNamespacedHelpers('customer');

export default {
  name: 'ClassificationRules',
  data() {
    return {
      headers: [
        { text: 'Document Type', value: 'documentType' },
        { text: 'Description', value: 'description' },
        { text: '', value: 'actions', sortable: false, align: 'end' },
      ],
      ruleId: null,
      showDeleteRuleModal: false,
      isDialogOpen: false,
    };
  },
  components: {
    ActionPrompt,
    CreateClassificationRule
  },
  watch: {
    'selectedCustomer.customer_id'() {
      this.fetchRules();
    },
  },
  computed: {
    ...rulesGetters({
      Rules: 'RULES',
      fetchRulesLoading: 'FETCH_RULES_LOADING',
      deleteRuleLoading: 'DELETE_RULE_LOADING',
    }),
    ...customerGetters({
      selectedCustomer: 'SELECTED_CUSTOMER',
    }),
    deleteMessageBody() {
      return 'Are you sure you want to delete this Classification Rule?';
    },
  },
  mounted() {
    this.fetchRules();
  },
  methods: {
    ...rulesActions(['fetchRules', 'deleteRule']),
    triggerDelete({ id }) {
      this.ruleId = id;
      this.showDeleteRuleModal = true;
    },
    async removeRule() {
      await this.deleteRule(this.ruleId);
      this.ruleId = null;
      this.showDeleteRuleModal = false;
    },
    editRule(item) {
      this.$router.push({ path: `/classification-rules/${item.id}` });
    },
    handleGoToRule(item) {
      this.$router.push({ path: `/classification-rules/${item.id}` });
    },
    isSystemRule(rule) {
      return !rule.customerId;
    },
    handleDialogClose() {
      this.isDialogOpen = false;
      this.fetchRules();
    },
  },
};
</script>

<style lang="scss" scoped>
.ClassificationRules {
  &__filter-row {
    margin-bottom: 16px;
  }

  &__data-table {
    background: white;

    &-row {
      cursor: pointer;

      &:hover {
        background-color: rgba(0, 0, 0, 0.04);
      }
    }
  }
}
</style>